export class SewingModel {
  name: string;
  minPrice: number;
  maxPrice?: number;
  unit?: string;
  constructor(name: string, minPrice: number, maxPrice?: number, unit?: string) {
    this.name = name;
    this.minPrice = minPrice;
    this.maxPrice = maxPrice;
    this.unit = unit;
  }
}
